import { apiSlice } from "../../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTables: builder.mutation({
      query: (body) => {
        console.log(body);
        return {
          url: "/connectpg/showTables",
          method: "POST",
          body: body,
        };
      },
    }),
    saveDataSource: builder.mutation({
      query: (body) => ({
        url: "/connectpg/saveDataSource",
        method: "POST",
        body: body,
      }),

    }),


    getLatestDraft: builder.query({
      query: () => ({
        url: "/workbookapi/latest-drafts",
        method: "GET",

      }),

    }),

  }),


});

export const { useGetTablesMutation, useSaveDataSourceMutation, useGetLatestDraftQuery } = sqlApiSlice;
